import { useState, useEffect, useCallback } from 'react';
import { getCertificates } from '../services/mypageApi';
import { Certificate } from '../types/certificate';

interface UseCertificatesProps {
  initialPageSize?: number;
}

interface UseCertificatesReturn {
  certificates: Certificate[];
  isLoading: boolean;
  error: string | null;
  currentPage: number;
  totalPages: number;
  totalElements: number;
  pageSize: number;
  fetchCertificates: (page?: number) => Promise<void>;
  refetch: () => Promise<void>;
}

export const useCertificates = ({ 
  initialPageSize = 8 
}: UseCertificatesProps = {}): UseCertificatesReturn => {
  const [certificates, setCertificates] = useState<Certificate[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [pageSize] = useState(initialPageSize);

  const fetchCertificates = useCallback(async (page: number = 0) => {
    setIsLoading(true);
    setError(null);
    
    try {
      const data = await getCertificates(page, pageSize);
      /// console.log('수료증 목록 조회 요청 및 결과:', { request: {page, pageSize}, response: {data} });
      
      setCertificates(data.content);
      setTotalPages(data.totalPages);
      setTotalElements(data.totalElements);
      setCurrentPage(data.number);
    } catch (err) {
      /// console.error('수료증 목록 조회 실패:', err);
      const errorMessage = err instanceof Error ? err.message : '수료증 목록을 불러오는데 실패했습니다.';
      setError(errorMessage);
      setCertificates([]);
    } finally {
      setIsLoading(false);
    }
  }, [pageSize]);

  const refetch = useCallback(() => {
    return fetchCertificates(currentPage);
  }, [fetchCertificates, currentPage]);

  useEffect(() => {
    fetchCertificates(0);
  }, [fetchCertificates]);

  return {
    certificates,
    isLoading,
    error,
    currentPage,
    totalPages,
    totalElements,
    pageSize,
    fetchCertificates,
    refetch,
  };
};
